import { render } from "./ArtworkPreviewModal.vue?vue&type=template&id=3815a035"
import script from "./ArtworkPreviewModal.vue?vue&type=script&lang=js"
export * from "./ArtworkPreviewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__